var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfBorderTicks = function SvgPdfBorderTicks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 15.5v-7h1.616v7zm15.385 0v-7H20.5v7zM7.345 12.808v-1.616h1.615v1.616zm3.846 0v-1.616h1.616v1.616zm3.847 0v-1.616h1.615v1.616z"
  })));
};
export default SvgPdfBorderTicks;